
import { toString, Union, Record } from "../fable_modules/fable-library-js.5.0.0/Types.js";
import { Response_Model_$reflection } from "../StenaWeather.WeatherServiceUI.Shared/Dashboards/API.js";
import { union_type, record_type, list_type } from "../fable_modules/fable-library-js.5.0.0/Reflection.js";
import { ServerError_$reflection } from "../StenaWeather.WeatherServiceUI.Shared/Errors.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.5.0.0/Result.js";
import { toArray as toArray_1, ofArray, map, where, singleton, empty } from "../fable_modules/fable-library-js.5.0.0/List.js";
import { ModelUpdateStatus, ModelUpdateStatusModule_isUpToDate, ModelUpdateStatusModule_isToBeUpdated, ModelUpdateStatusModule_isOutdated } from "../StenaWeather.Domain/Models.js";
import { Cmd_none } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { onDashboardsAPI, Cmd_OfAsync_eitherAsResult } from "../Server.js";
import { add, utcNow, op_Subtraction, toUniversalTime, fromTicks } from "../fable_modules/fable-library-js.5.0.0/DateOffset.js";
import { toFloat64, op_Subtraction as op_Subtraction_1, op_Addition, toInt64_unchecked } from "../fable_modules/fable-library-js.5.0.0/BigInt.js";
import { fromTicks as fromTicks_1, op_Multiply, ticks as ticks_1 } from "../fable_modules/fable-library-js.5.0.0/TimeSpan.js";
import { compare, getTicks } from "../fable_modules/fable-library-js.5.0.0/Date.js";
import Dashboard$002Emodule from "../../src/StenaWeather.WeatherServiceUI.Client/Pages/Dashboard.module.scss";
import { toText, concat, join } from "../fable_modules/fable-library-js.5.0.0/String.js";
import { createObj, stringHash, equals, comparePrimitives, defaultOf } from "../fable_modules/fable-library-js.5.0.0/Util.js";
import { createElement } from "react";
import React from "react";
import { defaultOf as defaultOf_1 } from "../fable_modules/fable-library-js.5.0.0/Util.js";
import { TagModule_View } from "../Components/StenaWebUI/Elements/Tag.js";
import { ofList } from "../fable_modules/fable-library-js.5.0.0/Map.js";
import { formatToMultipleUnits, formatToWholeUnits } from "../TimeSpan.js";
import { TextModule_View } from "../Components/StenaWebUI/Core/Text.js";
import { DateTimeOffset_DateTimeWithTimezone, DateTimeOffset_dateTimeWithTimezone } from "../Components/TimeZones/Components.js";
import { WhiteSpaceType, UserSelectType, TextVariant, TextSize } from "../Components/StenaWebUI/Core/Text.js";
import { IconModule_View } from "../Components/StenaWebUI/Icons/Icon.js";
import { faCheckCircle, faExclamation, faExclamationTriangle, faCircle } from "@fortawesome/free-solid-svg-icons";
import { Color, theme } from "../Theme.js";
import { ModelUpdateStatus_value } from "./Models.js";
import { HtmlHelper_createElement } from "../fable_modules/Feliz.3.3.3/Html.fs.js";
import { SpaceModule_View } from "../Components/StenaWebUI/Core/Space.js";
import { RowModule_View } from "../Components/StenaWebUI/Core/Row.js";
import { ProgressBarModule_ViewLinear } from "../Components/Rc-progress/rc-progress.js";
import { UseElmishHelper_programWithCustomErrorHandler, React_useElmish_Z6C327F2E } from "../fable_modules/Feliz.UseElmish.5.0.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { Array_except } from "../fable_modules/fable-library-js.5.0.0/Seq2.js";
import { toArray, collect, singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0/Seq.js";
import { PageTitle_title } from "../SharedView.js";
import { HeadingModule_View } from "../Components/StenaWebUI/Core/Heading.js";
import { StandardTableModule_view } from "../Components/StenaWebUI/Grid/StandardTable.js";

export class State extends Record {
    constructor(Warnings, Cautions, Updated) {
        super();
        this.Warnings = Warnings;
        this.Cautions = Cautions;
        this.Updated = Updated;
    }
}

export function State_$reflection() {
    return record_type("StenaWeather.WeatherServiceUI.Client.Pages.Dashboard.State", [], State, () => [["Warnings", list_type(Response_Model_$reflection())], ["Cautions", list_type(Response_Model_$reflection())], ["Updated", list_type(Response_Model_$reflection())]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadModels", "OnModelsLoaded"];
    }
}

export function Msg_$reflection() {
    return union_type("StenaWeather.WeatherServiceUI.Client.Pages.Dashboard.Msg", [], Msg, () => [[], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(Response_Model_$reflection()), ServerError_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(Response_Model_$reflection())]], [["ErrorValue", ServerError_$reflection()]]])]]]);
}

export function init() {
    return [new State(empty(), empty(), empty()), singleton((dispatch) => {
        dispatch(new Msg(0, []));
    })];
}

export function update(msg, state) {
    if (msg.tag === 1) {
        const result = msg.fields[0];
        if (result.tag === 0) {
            const models = result.fields[0];
            return [new State(where((f) => ModelUpdateStatusModule_isOutdated(f.Status), models), where((f_1) => ModelUpdateStatusModule_isToBeUpdated(f_1.Status), models), where((f_2) => ModelUpdateStatusModule_isUpToDate(f_2.Status), models)), Cmd_none()];
        }
        else {
            return [state, Cmd_none()];
        }
    }
    else {
        return [state, Cmd_OfAsync_eitherAsResult(() => onDashboardsAPI((x) => x.GetModels()), (Item) => (new Msg(1, [Item])))];
    }
}

export function getNextAlarmTriggeredDateTimeOffset(alertCoef, updateFreq, lastUpdated) {
    return fromTicks(toInt64_unchecked(op_Addition(ticks_1(op_Multiply(alertCoef, updateFreq)), getTicks(toUniversalTime(lastUpdated)))), 0);
}

export const cn = (() => {
    const styles = Dashboard$002Emodule;
    const cnFn = (name) => (styles[name]);
    const cnFns = (names) => map((x) => (styles[x]), names);
    return {
        className: cnFn,
        classes: cnFns,
        prop: {
            className: (arg) => ["className", cnFn(arg)],
            classes: (arg_1) => ["className", join(" ", cnFns(arg_1))],
        },
    };
})();

const StandardTable_constants_itemTypeInstance = defaultOf();

export const StandardTable_constants_modelColumnName = "ModelName";

export const StandardTable_constants_statusColumnName = "Status";

export const StandardTable_constants_updateFreqColumnName = "UpdateFrequency";

export const StandardTable_constants_lastUpdatedColumnName = "Downloaded";

export const StandardTable_constants_lastUpdatedDtColumnName = "DownloadedDT";

export const StandardTable_constants_forecastCreatedDtColumnName = "LastUpdatedDT";

export const StandardTable_constants_expectedUpdateColumnName = "expectedUpdate";

export const StandardTable_constants_expectedUpdateDtColumnName = "expectedUpdateDT";

export const StandardTable_constants_alarmCriteriaColumnName = "alarmCriteria";

export const StandardTable_constants_triggerAlarmColumnName = "triggerAlarm";

export const StandardTable_constants_triggerAlarmDtColumnName = "triggerAlarmDT";

export const StandardTable_constants_iconColumnName = "infoIcon";

export const StandardTable_constants_defaultColumnWidth = 130;

export const StandardTable_constants_warningsHeader = "Warnings";

export const StandardTable_constants_cautionsHeader = "Cautions";

export const StandardTable_constants_onTimeHeader = "Updated on time";

export function StandardTable_divs_emptyDiv($props) {
    const _arg = $props._arg1;
    return defaultOf_1();
}

export function StandardTable_divs_renderUpdateFreqCell($props) {
    const p = $props.p;
    return TagModule_View(ofList(map((value) => value, ofArray([["variant", "passive"], ["size", "medium"], ["label", formatToWholeUnits(p.item.UpdateFrequency)]])), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }));
}

export function StandardTable_divs_renderSomeTimeAgoCell(p) {
    return TextModule_View(ofList(map((value_1) => value_1, singleton(["children", concat(formatToMultipleUnits(op_Subtraction(utcNow(), DateTimeOffset_dateTimeWithTimezone(p))), ..." ago")])), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }));
}

export function StandardTable_divs_renderExpectedUpdateCell(p) {
    if (compare(p.value, utcNow()) < 0) {
        return StandardTable_divs_renderSomeTimeAgoCell(p.value);
    }
    else {
        return TextModule_View(ofList(map((value_1) => value_1, ofArray([["children", "in " + formatToMultipleUnits(op_Subtraction(DateTimeOffset_dateTimeWithTimezone(p.value), utcNow()))], ["size", new TextSize(1, [])]])), {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        }));
    }
}

export function StandardTable_divs_renderLastUpdatedCell(p) {
    return StandardTable_divs_renderSomeTimeAgoCell(p.value);
}

export function StandardTable_divs_renderDefaultDateTimeOffsetFormattedCell(p) {
    return TextModule_View(ofList(map((value) => value, singleton(["children", singleton(createElement(DateTimeOffset_DateTimeWithTimezone, {
        dateTime: p.value,
    }))])), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }));
}

export function StandardTable_divs_renderCellForStatus(f) {
    let t_4, t_7, t_1;
    let icon;
    const matchValue = f.value;
    icon = ((matchValue.tag === 1) ? IconModule_View(ofList(map((value_1) => value_1, ofArray([["size", 10], (t_4 = faCircle, ["icon", t_4]), ["color", theme(new Color(20, []))]])), {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    })) : ((matchValue.tag === 2) ? IconModule_View(ofList(map((value_2) => value_2, ofArray([["size", 10], (t_7 = faCircle, ["icon", t_7]), ["color", theme(new Color(19, []))]])), {
        Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
    })) : IconModule_View(ofList(map((value) => value, ofArray([["size", 10], (t_1 = faCircle, ["icon", t_1]), ["color", theme(new Color(21, []))]])), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }))));
    const text = TextModule_View(ofList(map((value_4) => value_4, ofArray([["variant", new TextVariant(0, [])], ["size", new TextSize(1, [])], ["color", theme(new Color(3, []))], ["userSelect", new UserSelectType(6, [])], ["whiteSpace", new WhiteSpaceType(4, [])], ["children", ModelUpdateStatus_value(f.item.Status)]])), {
        Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
    }));
    return HtmlHelper_createElement("div", ofArray([["className", cn.className("statusCell")], ["children", [icon, text]]]));
}

export function StandardTable_divs_renderIconCell(f) {
    let t_4, t_7, t_1;
    let icon;
    const matchValue = f.value;
    icon = ((matchValue.tag === 1) ? IconModule_View(ofList(map((value_1) => value_1, ofArray([["size", 16], (t_4 = faExclamationTriangle, ["icon", t_4]), ["color", theme(new Color(20, []))]])), {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    })) : ((matchValue.tag === 2) ? IconModule_View(ofList(map((value_2) => value_2, ofArray([["size", 16], (t_7 = faExclamation, ["icon", t_7]), ["color", theme(new Color(19, []))]])), {
        Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
    })) : IconModule_View(ofList(map((value) => value, ofArray([["size", 16], (t_1 = faCheckCircle, ["icon", t_1]), ["color", theme(new Color(21, []))]])), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }))));
    return HtmlHelper_createElement("div", ofArray([["className", cn.className("iconCell")], ["children", singleton(icon)]]));
}

export function StandardTable_divs_renderModelCell(p) {
    return HtmlHelper_createElement("div", ofArray([["className", cn.className("supplierCell")], ["children", [TextModule_View(ofList(map((value_4) => value_4, ofArray([["variant", new TextVariant(3, [])], ["size", new TextSize(0, [])], ["userSelect", new UserSelectType(6, [])], ["whiteSpace", new WhiteSpaceType(4, [])], ["children", p.item.ModelName]])), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    })), TextModule_View(ofList(map((value_6) => value_6, ofArray([["variant", new TextVariant(0, [])], ["size", new TextSize(1, [])], ["color", theme(new Color(3, []))], ["userSelect", new UserSelectType(6, [])], ["whiteSpace", new WhiteSpaceType(4, [])], ["children", toString(p.item.Provider)]])), {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    }))]]]));
}

export function StandardTable_divs_renderAlarmCriteriaCell(p) {
    let p_1_2;
    let pct;
    const value = p.value * 100;
    pct = value.toString();
    const tagValue = formatToMultipleUnits((p.item.UpdateFrequency * p.value) - p.item.UpdateFrequency);
    const p_1_5 = ofList(map((value_7) => value_7, singleton(["children", ofArray([TextModule_View(ofList(map((value_3) => value_3, singleton(["children", pct + "%"])), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    })), (p_1_2 = ofList(map((value_4) => value_4, empty()), {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    }), createElement(SpaceModule_View, {
        p: p_1_2,
    })), TagModule_View(ofList(map((value_5) => value_5, ofArray([["variant", "passive"], ["size", "medium"], ["label", tagValue]])), {
        Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
    }))])])), {
        Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
    });
    return createElement(RowModule_View, {
        p: p_1_5,
    });
}

export function StandardTable_divs_renderAlarmDateTimeOffset(p) {
    return TextModule_View(ofList(map((value) => value, ofArray([["children", singleton(createElement(DateTimeOffset_DateTimeWithTimezone, {
        dateTime: p.value,
    }))], ["size", new TextSize(1, [])]])), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }));
}

export function StandardTable_divs_renderAlarmProgressBar(p) {
    const nextAlarmDt = p.value;
    const textColor = equals(p.item.Status, new ModelUpdateStatus(2, [])) ? theme(new Color(19, [])) : theme(new Color(0, []));
    if (compare(nextAlarmDt, utcNow()) < 0) {
        return TextModule_View(ofList(map((value_1) => value_1, ofArray([["children", concat(formatToMultipleUnits(fromTicks_1(toInt64_unchecked(op_Subtraction_1(getTicks(utcNow()), getTicks(nextAlarmDt))))), ..." ago")], ["color", textColor]])), {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        }));
    }
    else {
        const nextAlarmIn = op_Subtraction(nextAlarmDt, utcNow());
        const progressPct = ~~((toFloat64(ticks_1(nextAlarmIn)) / (p.item.OutdatedAlertCoefficient * toFloat64(ticks_1(p.item.UpdateFrequency)))) * 100) | 0;
        return HtmlHelper_createElement("div", ofArray([["className", cn.className("progressCell")], ["children", [HtmlHelper_createElement("div", ofArray([["className", cn.className("progressBar")], ["children", singleton(ProgressBarModule_ViewLinear(ofList(map((value_12) => value_12, ofArray([["percent", `${progressPct}`], ["strokeColor", ModelUpdateStatusModule_isUpToDate(p.item.Status) ? "green" : "orange"], ["strokeWidth", 4]])), {
            Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
        })))]])), HtmlHelper_createElement("div", ofArray([["className", cn.className("progressLegend")], ["children", singleton(TextModule_View(ofList(map((value_18) => value_18, ofArray([["children", concat("in ", ...formatToMultipleUnits(nextAlarmIn))], ["size", new TextSize(1, [])]])), {
            Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
        })))]]))]]]));
    }
}

export function getNoDataText(header) {
    if (header === "Warnings") {
        return ["There are no warnings.", "Everything is updated on time. No warning alarms in this moment."];
    }
    else {
        return [defaultOf(), "There is no data available"];
    }
}

export function DashboardView() {
    const state_1 = React_useElmish_Z6C327F2E(() => UseElmishHelper_programWithCustomErrorHandler(undefined, ProgramModule_mkProgram(init, update, (_arg, _arg_1) => {
    })), undefined, [])[0];
    const warningsColumnOrder = [StandardTable_constants_iconColumnName, StandardTable_constants_modelColumnName, StandardTable_constants_statusColumnName, StandardTable_constants_updateFreqColumnName, StandardTable_constants_lastUpdatedColumnName, StandardTable_constants_lastUpdatedDtColumnName, StandardTable_constants_expectedUpdateColumnName, StandardTable_constants_expectedUpdateDtColumnName, StandardTable_constants_alarmCriteriaColumnName, StandardTable_constants_triggerAlarmColumnName, StandardTable_constants_triggerAlarmDtColumnName, StandardTable_constants_forecastCreatedDtColumnName];
    const columnOrder = Array_except([StandardTable_constants_triggerAlarmDtColumnName], warningsColumnOrder, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    });
    return HtmlHelper_createElement("div", ofArray([["className", cn.className("contentDiv")], ["children", toList(delay(() => append(singleton_1(PageTitle_title("Dashboard", "All forecast models")), delay(() => collect((matchValue) => {
        let p_1_1, columnProps, columnProps_1, columnProps_2, columnProps_3, columnProps_4, columnProps_5, infoIconTooltipText, columnProps_6, columnProps_7, columnProps_8, columnProps_9, columnProps_10, columnProps_11;
        const header = matchValue[0];
        const patternInput_1 = getNoDataText(header);
        return singleton_1(HtmlHelper_createElement("div", ofArray([["className", cn.className("tableWithHeading")], ["children", [(p_1_1 = ofList(map((value_7) => value_7, ofArray([["children", singleton(header)], ["variant", "h5"]])), {
            Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
        }), createElement(HeadingModule_View, {
            p: p_1_1,
        })), StandardTableModule_view(createObj(toList([["variant", "relaxed"], ["items", toArray(toArray_1(matchValue[1]))], ["noItemsHeader", patternInput_1[0]], ["noItemsLabel", patternInput_1[1]], ["config", createObj(toList([["keyResolver", (i) => i.ModelName], ["disableSorting", true], ["rowBackgroundResolver", (i_1) => {
            if (equals(i_1.Status, new ModelUpdateStatus(2, []))) {
                return {
                    background: theme(new Color(16, [])),
                };
            }
            else if (equals(i_1.Status, new ModelUpdateStatus(1, []))) {
                return {
                    background: theme(new Color(17, [])),
                };
            }
            else {
                return {
                    background: theme(new Color(1, [])),
                };
            }
        }], ["columns", createObj([(columnProps = createObj(toList([["name", StandardTable_constants_iconColumnName], ["itemValueResolver", (i_2) => i_2.Status], ["columnLabel", ""], ["width", toText(`${40}px`)], ["renderCell", StandardTable_divs_renderIconCell]])), [columnProps.name, columnProps]), (columnProps_1 = createObj(toList([["name", StandardTable_constants_modelColumnName], ["itemValueResolver", (value_8) => {
        }], ["columnLabel", "Model/Supplier"], ["width", toText(`${StandardTable_constants_defaultColumnWidth}px`)], ["renderCell", StandardTable_divs_renderModelCell]])), [columnProps_1.name, columnProps_1]), (columnProps_2 = createObj(toList([["name", StandardTable_constants_statusColumnName], ["itemValueResolver", (i_3) => i_3.Status], ["columnLabel", "Status"], ["width", toText(`${StandardTable_constants_defaultColumnWidth}px`)], ["renderCell", StandardTable_divs_renderCellForStatus]])), [columnProps_2.name, columnProps_2]), (columnProps_3 = createObj(toList([["name", StandardTable_constants_updateFreqColumnName], ["itemValueResolver", (i_4) => i_4.UpdateFrequency], ["columnLabel", "Update freq."], ["width", toText(`${StandardTable_constants_defaultColumnWidth}px`)], ["renderCell", (p_3) => createElement(StandardTable_divs_renderUpdateFreqCell, {
            p: p_3,
        })]])), [columnProps_3.name, columnProps_3]), (columnProps_4 = createObj(toList([["name", StandardTable_constants_lastUpdatedColumnName], ["itemValueResolver", (i_5) => i_5.Downloaded], ["columnLabel", "Last updated"], ["width", toText(`${StandardTable_constants_defaultColumnWidth}px`)], ["renderCell", StandardTable_divs_renderLastUpdatedCell]])), [columnProps_4.name, columnProps_4]), (columnProps_5 = createObj(toList([["name", StandardTable_constants_lastUpdatedDtColumnName], ["itemValueResolver", (i_6) => i_6.Downloaded], ["columnLabel", "Last updated date time"], (infoIconTooltipText = "Definition: File transfers: date when forecast was available for consumption in Weather Service. API based model: date when forecast was created by weather supplier.", ["infoIconTooltipText", infoIconTooltipText]), ["width", toText(`${StandardTable_constants_defaultColumnWidth}px`)], ["renderCell", StandardTable_divs_renderDefaultDateTimeOffsetFormattedCell]])), [columnProps_5.name, columnProps_5]), (columnProps_6 = createObj(toList([["name", StandardTable_constants_expectedUpdateColumnName], ["itemValueResolver", (i_7) => add(i_7.Downloaded, i_7.UpdateFrequency)], ["columnLabel", "Expected update time"], ["width", toText(`${StandardTable_constants_defaultColumnWidth}px`)], ["renderCell", StandardTable_divs_renderExpectedUpdateCell]])), [columnProps_6.name, columnProps_6]), (columnProps_7 = createObj(toList([["name", StandardTable_constants_expectedUpdateDtColumnName], ["itemValueResolver", (i_8) => add(i_8.Downloaded, i_8.UpdateFrequency)], ["columnLabel", "Expected update date time"], ["width", toText(`${StandardTable_constants_defaultColumnWidth}px`)], ["renderCell", StandardTable_divs_renderDefaultDateTimeOffsetFormattedCell]])), [columnProps_7.name, columnProps_7]), (columnProps_8 = createObj(toList([["name", StandardTable_constants_alarmCriteriaColumnName], ["itemValueResolver", (i_9) => i_9.OutdatedAlertCoefficient], ["columnLabel", "Alarm criteria"], ["width", toText(`${StandardTable_constants_defaultColumnWidth}px`)], ["infoIconTooltipText", "% delay allowed"], ["renderCell", StandardTable_divs_renderAlarmCriteriaCell]])), [columnProps_8.name, columnProps_8]), (columnProps_9 = createObj(toList([["name", StandardTable_constants_triggerAlarmColumnName], ["itemValueResolver", (i_10) => getNextAlarmTriggeredDateTimeOffset(i_10.OutdatedAlertCoefficient, i_10.UpdateFrequency, i_10.Downloaded)], ["columnLabel", (header === StandardTable_constants_warningsHeader) ? "" : "Trigger alarm"], ["width", toText(`${(header === StandardTable_constants_warningsHeader) ? StandardTable_constants_defaultColumnWidth : (StandardTable_constants_defaultColumnWidth * 2)}px`)], ["renderCell", (header === StandardTable_constants_warningsHeader) ? ((arg00$0040_1) => createElement(StandardTable_divs_emptyDiv, {
            tuple_0: arg00$0040_1,
        })) : (StandardTable_divs_renderAlarmProgressBar)]])), [columnProps_9.name, columnProps_9]), (columnProps_10 = createObj(toList([["name", StandardTable_constants_triggerAlarmDtColumnName], ["itemValueResolver", (i_11) => getNextAlarmTriggeredDateTimeOffset(i_11.OutdatedAlertCoefficient, i_11.UpdateFrequency, i_11.Downloaded)], ["columnLabel", "Trigger alarm date time"], ["width", toText(`${StandardTable_constants_defaultColumnWidth}px`)], ["renderCell", StandardTable_divs_renderAlarmDateTimeOffset]])), [columnProps_10.name, columnProps_10]), (columnProps_11 = createObj(toList([["name", StandardTable_constants_forecastCreatedDtColumnName], ["itemValueResolver", (i_12) => i_12.LastUpdated], ["columnLabel", "Forecast created date time"], ["infoIconTooltipText", "Definition: Date when forecast was created at data center by the weather supplier"], ["width", toText(`${StandardTable_constants_defaultColumnWidth}px`)], ["renderCell", StandardTable_divs_renderDefaultDateTimeOffsetFormattedCell]])), [columnProps_11.name, columnProps_11])])], ["columnOrder", (header === StandardTable_constants_warningsHeader) ? warningsColumnOrder : columnOrder]]))]])))]]])));
    }, [[StandardTable_constants_warningsHeader, state_1.Warnings], [StandardTable_constants_cautionsHeader, state_1.Cautions], [StandardTable_constants_onTimeHeader, state_1.Updated]])))))]]));
}

